export default "__VITE_ASSET__DMb1A4Tq__"